import { MENU_CODE } from '~/constants/menu'

export const useArticleSection = () => {
  const eventName = 'click_blog_home'
  const { analyticEvent, fbPixelEvent } = useAnalytic()
  const { getPath } = useNavigationMenu()

  const eventHomeArticle = (title: string) => {
    analyticEvent({
      ga4ActionName: 'click_blog_home',
      ga4Label: title,
    })
    fbPixelEvent({
      fbCategory: 'trackCustom',
      fbEvent: 'Blog - Home',
      fbValue: { label: title },
    })
  }

  return {
    MENU_CODE,
    eventName,
    eventHomeArticle,
    getPath,
  }
}
